"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var widthWrapperMobile = "144px";
var widthClub = "38px";
var widthVs = "24px";

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: ", ";\n  max-width: ", ";\n  min-width: ", ";\n\n  @media (min-width: ", ") {\n    flex: 1 1 auto;\n  }\n"])), widthWrapperMobile, widthWrapperMobile, widthWrapperMobile, function (props) {
  return props.theme.screenWidthMd;
});

var StyledFixtureInfo = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 90px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));

var StyledFixtureInfoUpper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 2px;\n"])));

var StyledEndBlock = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 54px;\n  flex: 0 0 54px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));

var StyledKitImage = _styledComponents.default.img(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 22px;\n  margin-bottom: 2px;\n"])));

var StyledIconWrapper = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.25rem;\n  width: 24px;\n  height: 24px;\n  background: ", ";\n"])), function (p) {
  return p.isActive ? "transparent" : p.isSuccess ? p.theme.colorSuccess : null;
});

var StyledLockIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n"])), function (p) {
  return p.isSuccess && !p.isActive ? "16px" : "20px";
}, function (p) {
  return p.isActive ? p.theme.colorDarkText : p.isSuccess ? p.theme.colorSuccessText : p.theme.colorText;
});

var StyledClub = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding-top: 3px;\n"])));

var StyledClubName = (0, _styledComponents.default)(_fiverReactUiComponents.ClubName)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  text-align: center;\n  font-size: 0.75rem;\n  color: ", ";\n"])), widthClub, widthClub, widthClub, function (p) {
  return p.isActive ? p.theme.colorDarkText : p.theme.colorText;
});

var StyledVs = _styledComponents.default.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-size: 0.875rem;\n  width: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  text-align: center;\n  color: ", ";\n"])), widthVs, widthVs, widthVs, function (p) {
  return p.isActive ? p.theme.colorDarkText : p.theme.colorText;
});

var Wrapper = function Wrapper(_ref) {
  var _pickem$activeBet, _pickem$activeBet2, _pickem$footballMatch, _pickem$footballMatch2, _pickem$footballMatch3, _pickem$footballMatch4, _pickem$footballMatch5, _pickem$footballMatch6, _pickem$footballMatch7, _pickem$footballMatch8, _pickem$footballMatch9, _pickem$footballMatch10, _pickem$footballMatch11, _pickem$footballMatch12;

  var pickem = _ref.pickem,
      isActive = _ref.isActive,
      showLogos = _ref.showLogos,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages;
  var isApproved = (pickem === null || pickem === void 0 ? void 0 : pickem.status) === "APPROVED";
  var prize = (pickem === null || pickem === void 0 ? void 0 : (_pickem$activeBet = pickem.activeBet) === null || _pickem$activeBet === void 0 ? void 0 : _pickem$activeBet.prize) || (pickem === null || pickem === void 0 ? void 0 : (_pickem$activeBet2 = pickem.activeBet) === null || _pickem$activeBet2 === void 0 ? void 0 : _pickem$activeBet2.promoPrize);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledEndBlock, {
      children: !isApproved ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIconWrapper, {
        isActive: isActive,
        isSuccess: prize,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLockIcon, {
          isActive: isActive,
          isSuccess: prize,
          children: prize ? "emoji_events" : pickem !== null && pickem !== void 0 && pickem.activeBet ? "cancel" : "horizontal_rule"
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLockIcon, {
        isActive: isActive,
        children: pickem !== null && pickem !== void 0 && pickem.activeBet ? "lock" : "horizontal_rule"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledFixtureInfo, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledFixtureInfoUpper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledClub, {
          children: [showLogos && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledKitImage, {
            src: isUsingAlternativeImages ? pickem === null || pickem === void 0 ? void 0 : (_pickem$footballMatch = pickem.footballMatch) === null || _pickem$footballMatch === void 0 ? void 0 : (_pickem$footballMatch2 = _pickem$footballMatch.homeTeam) === null || _pickem$footballMatch2 === void 0 ? void 0 : _pickem$footballMatch2.logoImg : pickem === null || pickem === void 0 ? void 0 : (_pickem$footballMatch3 = pickem.footballMatch) === null || _pickem$footballMatch3 === void 0 ? void 0 : (_pickem$footballMatch4 = _pickem$footballMatch3.homeTeam) === null || _pickem$footballMatch4 === void 0 ? void 0 : _pickem$footballMatch4.logo
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubName, {
            isActive: isActive,
            isLetters: true,
            children: pickem === null || pickem === void 0 ? void 0 : (_pickem$footballMatch5 = pickem.footballMatch) === null || _pickem$footballMatch5 === void 0 ? void 0 : (_pickem$footballMatch6 = _pickem$footballMatch5.homeTeam) === null || _pickem$footballMatch6 === void 0 ? void 0 : _pickem$footballMatch6.name
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledVs, {
          isActive: isActive,
          children: "vs"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledClub, {
          children: [showLogos && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledKitImage, {
            src: isUsingAlternativeImages ? pickem === null || pickem === void 0 ? void 0 : (_pickem$footballMatch7 = pickem.footballMatch) === null || _pickem$footballMatch7 === void 0 ? void 0 : (_pickem$footballMatch8 = _pickem$footballMatch7.awayTeam) === null || _pickem$footballMatch8 === void 0 ? void 0 : _pickem$footballMatch8.logoImg : pickem === null || pickem === void 0 ? void 0 : (_pickem$footballMatch9 = pickem.footballMatch) === null || _pickem$footballMatch9 === void 0 ? void 0 : (_pickem$footballMatch10 = _pickem$footballMatch9.awayTeam) === null || _pickem$footballMatch10 === void 0 ? void 0 : _pickem$footballMatch10.logo
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubName, {
            isActive: isActive,
            isLetters: true,
            children: pickem === null || pickem === void 0 ? void 0 : (_pickem$footballMatch11 = pickem.footballMatch) === null || _pickem$footballMatch11 === void 0 ? void 0 : (_pickem$footballMatch12 = _pickem$footballMatch11.awayTeam) === null || _pickem$footballMatch12 === void 0 ? void 0 : _pickem$footballMatch12.name
          })]
        })]
      })
    })]
  });
};

var _default = Wrapper;
exports.default = _default;